import React from 'react';
import { Star } from 'lucide-react';
export function SocialProof() {
  const testimonials = [{
    initials: 'MR',
    name: 'María Rodríguez',
    location: 'Buenos Aires',
    quote: 'Nunca había hecho un postre en mi vida. Empecé el curso hace un mes y ya tengo pedidos fijos todos los fines de semana. ¡La mejor inversión!'
  }, {
    initials: 'LG',
    name: 'Laura Gómez',
    location: 'Córdoba',
    quote: 'Las recetas son súper claras y los ingredientes re fáciles de conseguir. Pude empezar mi emprendimiento desde la cocina de mi casa sin gastar una fortuna.'
  }, {
    initials: 'SF',
    name: 'Sofía Fernández',
    location: 'Rosario',
    quote: 'Lo que más me sirvió fue la parte de cómo calcular los costos y ponerle precio. Antes vendía pero no veía ganancia, ahora es un negocio de verdad.'
  }];
  return <section className="py-20 bg-[#0d0906]" data-id="element-120">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-121">
        <div className="text-center mb-16" data-id="element-122">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-123">
            Lo que dicen{' '}
            <span className="text-[#d4a843]" data-id="element-124">nuestros alumnos</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-125">
          {testimonials.map((test, index) => <div key={index} className="glass-card p-8 relative" data-id="element-126">
              <div className="flex text-[#f0c14b] mb-4" data-id="element-127">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-128" />)}
              </div>
              <p className="text-[#c9b99a] italic mb-6" data-id="element-129">"{test.quote}"</p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-130">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#d4a843] to-[#f0c14b] flex items-center justify-center text-[#1a1008] font-bold text-lg" data-id="element-131">
                  {test.initials}
                </div>
                <div data-id="element-132">
                  <h4 className="text-white font-bold" data-id="element-133">{test.name}</h4>
                  <p className="text-sm text-[#c9b99a]/70" data-id="element-134">{test.location}</p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="flex flex-wrap justify-center gap-8 md:gap-16 border-y border-white/10 py-8" data-id="element-135">
          <div className="text-center" data-id="element-136">
            <div className="text-4xl font-bold text-[#f0c14b] mb-2" data-id="element-137">+500</div>
            <div className="text-[#c9b99a] uppercase tracking-wider text-sm font-semibold" data-id="element-138">
              Alumnos
            </div>
          </div>
          <div className="text-center" data-id="element-139">
            <div className="text-4xl font-bold text-[#f0c14b] mb-2" data-id="element-140">+15</div>
            <div className="text-[#c9b99a] uppercase tracking-wider text-sm font-semibold" data-id="element-141">
              Recetas
            </div>
          </div>
          <div className="text-center" data-id="element-142">
            <div className="text-4xl font-bold text-[#f0c14b] mb-2" data-id="element-143">4.9 ★</div>
            <div className="text-[#c9b99a] uppercase tracking-wider text-sm font-semibold" data-id="element-144">
              Valoración
            </div>
          </div>
        </div>
      </div>
    </section>;
}